export var ellipsisStyle = {
  display: 'inline-flex',
  textAlign: 'center',
  alignItems: 'center',
  padding: '0 8px'
};